// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_ListaResponse — GET /chamados/lista.
 *
 * `sou_suporte` viaja junto da lista porque a TELA precisa saber qual das duas
 * caras renderizar (a do solicitante ou a do atendente), e derivar isso no
 * frontend a partir dos grupos do JWT seria uma segunda cópia da regra de
 * autorização — que divergiria da do backend no dia em que uma das duas
 * mudasse. O backend já decidiu; a resposta conta.
 *
 * Isto é conveniência de RENDERIZAÇÃO, nunca de autorização: quem decide o que
 * pode é sempre o controller, a cada request.
 */
import type { Chamados_ChamadoRow } from './Chamados_ChamadoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_ListaResponseDados {
rows: Chamados_ChamadoRow[]
sou_suporte: boolean
}

export type Chamados_ListaResponse = ApiResponse<Chamados_ListaResponseDados>;

registerResponseContract('Chamados_ListaResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                     { type: 'number',  required: true },
      codigo:                 { type: 'string',  required: false },
      franquia_id:            { type: 'number',  required: false },
      franquia_nome:          { type: 'string',  required: false },
      aberto_por_nome:        { type: 'string',  required: false },
      assunto:                { type: 'string',  required: false },
      descricao:              { type: 'string',  required: false },
      status:                 { type: 'string',  required: false },
      prioridade:             { type: 'string',  required: false },
      pagina_uri:             { type: 'string',  required: false },
      os_id:                  { type: 'number',  required: false },
      cliente_id:             { type: 'number',  required: false },
      primeira_resposta_at:   { type: 'string',  required: false },
      resolvido_at:           { type: 'string',  required: false },
      created_at:             { type: 'string',  required: false },
      updated_at:             { type: 'string',  required: false },
      ultima_interacao_em:    { type: 'string',  required: false },
      ultima_interacao_texto: { type: 'string',  required: false },
      agente:                 { type: 'string',  required: false },
      agente_marcado_por:     { type: 'string',  required: false },
      agente_marcado_at:      { type: 'string',  required: false },
    },
  },
  sou_suporte: { type: 'boolean', required: true },
})
